module.exports = __webpack_public_path__ + "static/media/bri-logo-png.7c48e362.png";